export const CODING_TEMPLATE_PACK = {
  EXISTING: 'existing',
  BACKEND: 'backend',
  FRONTEND: 'frontend',
};

export const CODING_TEMPLATE_PACK_OPTIONS = [
  { id: CODING_TEMPLATE_PACK.EXISTING, label: 'Existing Templates' },
  { id: CODING_TEMPLATE_PACK.BACKEND, label: 'Backend Developer' },
  { id: CODING_TEMPLATE_PACK.FRONTEND, label: 'Frontend Developer' },
];

export const CODING_TEMPLATES = [
  {
    id: 'remove-duplicates-sorted-array',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Remove Duplicates from Sorted Array',
    difficulty: 'Easy',
    duration: 25,
    prompt: 'Remove duplicates in-place from a sorted array and return the unique count.',
    problemStatement:
      'Given a sorted integer array nums, remove duplicates in-place so each unique element appears once. Return the number of unique elements.',
    sampleInput: '[0,0,1,1,1,2,2,3,3,4]',
    sampleOutput: '5',
    evaluationLogic: [
      'Uses two pointers for in-place update',
      'Returns correct unique element count',
      'Preserves sorted order in first k positions',
    ],
    starterByLanguage: {
      javascript: 'function removeDuplicates(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function removeDuplicates(nums) {\n  // Write your code here\n}\nmodule.exports = { removeDuplicates };\n',
      python: 'def remove_duplicates(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int removeDuplicates(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function removeDuplicates(nums) {\n  if (!nums.length) return 0;\n  let k = 1;\n  for (let i = 1; i < nums.length; i += 1) {\n    if (nums[i] !== nums[k - 1]) {\n      nums[k] = nums[i];\n      k += 1;\n    }\n  }\n  return k;\n}\n',
      nodejs:
        'function removeDuplicates(nums) {\n  if (!nums.length) return 0;\n  let k = 1;\n  for (let i = 1; i < nums.length; i += 1) {\n    if (nums[i] !== nums[k - 1]) {\n      nums[k] = nums[i];\n      k += 1;\n    }\n  }\n  return k;\n}\nmodule.exports = { removeDuplicates };\n',
      python:
        'def remove_duplicates(nums):\n    if not nums:\n        return 0\n    k = 1\n    for i in range(1, len(nums)):\n        if nums[i] != nums[k - 1]:\n            nums[k] = nums[i]\n            k += 1\n    return k\n',
      java:
        'class Solution {\n  public int removeDuplicates(int[] nums) {\n    if (nums.length == 0) return 0;\n    int k = 1;\n    for (int i = 1; i < nums.length; i++) {\n      if (nums[i] != nums[k - 1]) {\n        nums[k] = nums[i];\n        k++;\n      }\n    }\n    return k;\n  }\n}\n',
    },
  },
  {
    id: 'even-number-of-digits',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Check Even Number of Digits',
    difficulty: 'Easy',
    duration: 25,
    prompt: 'Count numbers in an array that contain an even number of digits.',
    problemStatement:
      'Given an integer array nums, return how many numbers in the array have an even number of digits.',
    sampleInput: '[12,345,2,6,7896]',
    sampleOutput: '2',
    evaluationLogic: [
      'Counts digits for each number accurately',
      'Handles zero and large values',
      'Returns exact total count',
    ],
    starterByLanguage: {
      javascript: 'function findNumbers(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function findNumbers(nums) {\n  // Write your code here\n}\nmodule.exports = { findNumbers };\n',
      python: 'def find_numbers(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int findNumbers(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function findNumbers(nums) {\n  let count = 0;\n  for (const num of nums) {\n    const digits = String(Math.abs(num)).length;\n    if (digits % 2 === 0) count += 1;\n  }\n  return count;\n}\n',
      nodejs:
        'function findNumbers(nums) {\n  let count = 0;\n  for (const num of nums) {\n    const digits = String(Math.abs(num)).length;\n    if (digits % 2 === 0) count += 1;\n  }\n  return count;\n}\nmodule.exports = { findNumbers };\n',
      python:
        'def find_numbers(nums):\n    count = 0\n    for num in nums:\n        digits = len(str(abs(num)))\n        if digits % 2 == 0:\n            count += 1\n    return count\n',
      java:
        'class Solution {\n  public int findNumbers(int[] nums) {\n    int count = 0;\n    for (int num : nums) {\n      int digits = String.valueOf(Math.abs(num)).length();\n      if (digits % 2 == 0) count++;\n    }\n    return count;\n  }\n}\n',
    },
  },
  {
    id: 'count-vowels-string',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Count Vowels in String',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Count the total vowels in a string.',
    problemStatement:
      'Given a string s, return the total number of vowels (a, e, i, o, u) present in the string. Ignore case.',
    sampleInput: '"Education"',
    sampleOutput: '5',
    evaluationLogic: [
      'Counts vowels case-insensitively',
      'Ignores consonants and symbols',
      'Returns numeric count',
    ],
    starterByLanguage: {
      javascript: 'function countVowels(s) {\n  // Write your code here\n}\n',
      nodejs:
        'function countVowels(s) {\n  // Write your code here\n}\nmodule.exports = { countVowels };\n',
      python: 'def count_vowels(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int countVowels(String s) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        "function countVowels(s) {\n  const vowels = new Set(['a', 'e', 'i', 'o', 'u']);\n  let count = 0;\n  for (const ch of s.toLowerCase()) {\n    if (vowels.has(ch)) count += 1;\n  }\n  return count;\n}\n",
      nodejs:
        "function countVowels(s) {\n  const vowels = new Set(['a', 'e', 'i', 'o', 'u']);\n  let count = 0;\n  for (const ch of s.toLowerCase()) {\n    if (vowels.has(ch)) count += 1;\n  }\n  return count;\n}\nmodule.exports = { countVowels };\n",
      python:
        "def count_vowels(s):\n    vowels = set('aeiou')\n    count = 0\n    for ch in s.lower():\n        if ch in vowels:\n            count += 1\n    return count\n",
      java:
        "class Solution {\n  public int countVowels(String s) {\n    String vowels = \"aeiou\";\n    int count = 0;\n    for (char ch : s.toLowerCase().toCharArray()) {\n      if (vowels.indexOf(ch) >= 0) count++;\n    }\n    return count;\n  }\n}\n",
    },
  },
  {
    id: 'string-length',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Find String Length',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Return the number of characters in a string.',
    problemStatement: 'Given a string s, return the length of s (total number of characters).',
    sampleInput: '"Hello"',
    sampleOutput: '5',
    evaluationLogic: [
      'Returns the correct character count',
      'Handles empty strings',
      'Treats the string as a sequence of characters (standard length semantics)',
    ],
    starterByLanguage: {
      javascript: 'function getStringLength(s) {\n  // Write your code here\n}\n',
      nodejs:
        'function getStringLength(s) {\n  // Write your code here\n}\nmodule.exports = { getStringLength };\n',
      python: 'def get_string_length(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int getStringLength(String s) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript: 'function getStringLength(s) {\n  return s.length;\n}\n',
      nodejs:
        'function getStringLength(s) {\n  return s.length;\n}\nmodule.exports = { getStringLength };\n',
      python: 'def get_string_length(s):\n    return len(s)\n',
      java:
        'class Solution {\n  public int getStringLength(String s) {\n    return s.length();\n  }\n}\n',
    },
  },
  {
    id: 'prime-number-check',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Prime Number Check',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Return whether a number is prime.',
    problemStatement: 'Given an integer n, return true if n is prime, otherwise return false.',
    sampleInput: '29',
    sampleOutput: 'true',
    evaluationLogic: [
      'Handles n <= 1 correctly',
      'Checks factors up to sqrt(n)',
      'Returns boolean result',
    ],
    starterByLanguage: {
      javascript: 'function isPrime(n) {\n  // Write your code here\n}\n',
      nodejs: 'function isPrime(n) {\n  // Write your code here\n}\nmodule.exports = { isPrime };\n',
      python: 'def is_prime(n):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public boolean isPrime(int n) {\n    // Write your code here\n    return false;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function isPrime(n) {\n  if (n <= 1) return false;\n  if (n === 2) return true;\n  if (n % 2 === 0) return false;\n  for (let i = 3; i * i <= n; i += 2) {\n    if (n % i === 0) return false;\n  }\n  return true;\n}\n',
      nodejs:
        'function isPrime(n) {\n  if (n <= 1) return false;\n  if (n === 2) return true;\n  if (n % 2 === 0) return false;\n  for (let i = 3; i * i <= n; i += 2) {\n    if (n % i === 0) return false;\n  }\n  return true;\n}\nmodule.exports = { isPrime };\n',
      python:
        'def is_prime(n):\n    if n <= 1:\n        return False\n    if n == 2:\n        return True\n    if n % 2 == 0:\n        return False\n    i = 3\n    while i * i <= n:\n        if n % i == 0:\n            return False\n        i += 2\n    return True\n',
      java:
        'class Solution {\n  public boolean isPrime(int n) {\n    if (n <= 1) return false;\n    if (n == 2) return true;\n    if (n % 2 == 0) return false;\n    for (int i = 3; i * i <= n; i += 2) {\n      if (n % i == 0) return false;\n    }\n    return true;\n  }\n}\n',
    },
  },
  {
    id: 'find-maximum-element-array',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Find Maximum Element in the Array',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Find the largest element in an integer array.',
    problemStatement: 'Given an integer array nums, return the maximum element in the array.',
    sampleInput: '[3,7,2,9,4]',
    sampleOutput: '9',
    evaluationLogic: [
      'Iterates through all elements',
      'Handles negative and mixed integers',
      'Returns single max value',
    ],
    starterByLanguage: {
      javascript: 'function findMax(nums) {\n  // Write your code here\n}\n',
      nodejs: 'function findMax(nums) {\n  // Write your code here\n}\nmodule.exports = { findMax };\n',
      python: 'def find_max(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int findMax(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function findMax(nums) {\n  let max = nums[0];\n  for (let i = 1; i < nums.length; i += 1) {\n    if (nums[i] > max) max = nums[i];\n  }\n  return max;\n}\n',
      nodejs:
        'function findMax(nums) {\n  let max = nums[0];\n  for (let i = 1; i < nums.length; i += 1) {\n    if (nums[i] > max) max = nums[i];\n  }\n  return max;\n}\nmodule.exports = { findMax };\n',
      python:
        'def find_max(nums):\n    max_value = nums[0]\n    for value in nums[1:]:\n        if value > max_value:\n            max_value = value\n    return max_value\n',
      java:
        'class Solution {\n  public int findMax(int[] nums) {\n    int max = nums[0];\n    for (int i = 1; i < nums.length; i++) {\n      if (nums[i] > max) max = nums[i];\n    }\n    return max;\n  }\n}\n',
    },
  },
  {
    id: 'binary-search-sorted-array',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Binary Search in Sorted Array',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Return the index of target in a sorted array, or -1 if missing.',
    problemStatement:
      'Given a sorted integer array nums in ascending order and an integer target, return the index of target. If target is not present, return -1.',
    sampleInput: 'nums=[-1,0,3,5,9,12], target=9',
    sampleOutput: '4',
    evaluationLogic: [
      'Uses O(log n) comparisons',
      'Handles empty array',
      'Returns -1 when target absent',
    ],
    starterByLanguage: {
      javascript: 'function binarySearch(nums, target) {\n  // Write your code here\n}\n',
      nodejs:
        'function binarySearch(nums, target) {\n  // Write your code here\n}\nmodule.exports = { binarySearch };\n',
      python: 'def binary_search(nums, target):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int binarySearch(int[] nums, int target) {\n    // Write your code here\n    return -1;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function binarySearch(nums, target) {\n  let lo = 0;\n  let hi = nums.length - 1;\n  while (lo <= hi) {\n    const mid = (lo + hi) >> 1;\n    if (nums[mid] === target) return mid;\n    if (nums[mid] < target) lo = mid + 1;\n    else hi = mid - 1;\n  }\n  return -1;\n}\n',
      nodejs:
        'function binarySearch(nums, target) {\n  let lo = 0;\n  let hi = nums.length - 1;\n  while (lo <= hi) {\n    const mid = (lo + hi) >> 1;\n    if (nums[mid] === target) return mid;\n    if (nums[mid] < target) lo = mid + 1;\n    else hi = mid - 1;\n  }\n  return -1;\n}\nmodule.exports = { binarySearch };\n',
      python:
        'def binary_search(nums, target):\n    lo, hi = 0, len(nums) - 1\n    while lo <= hi:\n        mid = (lo + hi) // 2\n        if nums[mid] == target:\n            return mid\n        if nums[mid] < target:\n            lo = mid + 1\n        else:\n            hi = mid - 1\n    return -1\n',
      java:
        'class Solution {\n  public int binarySearch(int[] nums, int target) {\n    int lo = 0, hi = nums.length - 1;\n    while (lo <= hi) {\n      int mid = (lo + hi) >>> 1;\n      if (nums[mid] == target) return mid;\n      if (nums[mid] < target) lo = mid + 1;\n      else hi = mid - 1;\n    }\n    return -1;\n  }\n}\n',
    },
  },
  {
    id: 'maximum-subarray-sum-kadane',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Maximum Subarray Sum (Kadane)',
    difficulty: 'Hard',
    duration: 30,
    prompt: 'Find the largest sum of any contiguous subarray.',
    problemStatement:
      'Given an integer array nums, return the maximum possible sum of a contiguous non-empty subarray.',
    sampleInput: '[-2,1,-3,4,-1,2,1,-5,4]',
    sampleOutput: '6',
    evaluationLogic: [
      'Linear scan / Kadane-style reasoning',
      'Handles all-negative arrays',
      'Returns the maximum sum value',
    ],
    starterByLanguage: {
      javascript: 'function maxSubArray(nums) {\n  // Write your code here\n}\n',
      nodejs: 'function maxSubArray(nums) {\n  // Write your code here\n}\nmodule.exports = { maxSubArray };\n',
      python: 'def max_sub_array(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int maxSubArray(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function maxSubArray(nums) {\n  let best = nums[0];\n  let cur = nums[0];\n  for (let i = 1; i < nums.length; i += 1) {\n    cur = Math.max(nums[i], cur + nums[i]);\n    best = Math.max(best, cur);\n  }\n  return best;\n}\n',
      nodejs:
        'function maxSubArray(nums) {\n  let best = nums[0];\n  let cur = nums[0];\n  for (let i = 1; i < nums.length; i += 1) {\n    cur = Math.max(nums[i], cur + nums[i]);\n    best = Math.max(best, cur);\n  }\n  return best;\n}\nmodule.exports = { maxSubArray };\n',
      python:
        'def max_sub_array(nums):\n    best = cur = nums[0]\n    for x in nums[1:]:\n        cur = max(x, cur + x)\n        best = max(best, cur)\n    return best\n',
      java:
        'class Solution {\n  public int maxSubArray(int[] nums) {\n    int best = nums[0];\n    int cur = nums[0];\n    for (int i = 1; i < nums.length; i++) {\n      cur = Math.max(nums[i], cur + nums[i]);\n      best = Math.max(best, cur);\n    }\n    return best;\n  }\n}\n',
    },
  },
  {
    id: 'two-sum-indices',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Two Sum (Return Indices)',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Find two indices whose values add up to the target.',
    problemStatement:
      'Given an integer array nums and an integer target, return zero-based indices [i, j] with i < j such that nums[i] + nums[j] === target. Exactly one solution exists. Assume distinct index pairs.',
    sampleInput: 'nums=[2,7,11,15], target=9',
    sampleOutput: '[0,1]',
    evaluationLogic: [
      'Avoids O(n^2) where a hash map applies',
      'Returns sorted indices i < j',
      'Uses each element at most once',
    ],
    starterByLanguage: {
      javascript: 'function twoSum(nums, target) {\n  // Write your code here\n}\n',
      nodejs: 'function twoSum(nums, target) {\n  // Write your code here\n}\nmodule.exports = { twoSum };\n',
      python: 'def two_sum(nums, target):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int[] twoSum(int[] nums, int target) {\n    // Write your code here\n    return new int[] {0, 1};\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function twoSum(nums, target) {\n  const map = new Map();\n  for (let i = 0; i < nums.length; i += 1) {\n    const need = target - nums[i];\n    if (map.has(need)) return [map.get(need), i];\n    map.set(nums[i], i);\n  }\n  return [-1, -1];\n}\n',
      nodejs:
        'function twoSum(nums, target) {\n  const map = new Map();\n  for (let i = 0; i < nums.length; i += 1) {\n    const need = target - nums[i];\n    if (map.has(need)) return [map.get(need), i];\n    map.set(nums[i], i);\n  }\n  return [-1, -1];\n}\nmodule.exports = { twoSum };\n',
      python:
        'def two_sum(nums, target):\n    seen = {}\n    for i, n in enumerate(nums):\n        need = target - n\n        if need in seen:\n            return [seen[need], i]\n        seen[n] = i\n    return [-1, -1]\n',
      java:
        'class Solution {\n  public int[] twoSum(int[] nums, int target) {\n    java.util.Map<Integer, Integer> map = new java.util.HashMap<>();\n    for (int i = 0; i < nums.length; i++) {\n      int need = target - nums[i];\n      if (map.containsKey(need)) return new int[] { map.get(need), i };\n      map.put(nums[i], i);\n    }\n    return new int[] { -1, -1 };\n  }\n}\n',
    },
  },
  {
    id: 'trapping-rain-water',
    pack: CODING_TEMPLATE_PACK.EXISTING,
    title: 'Trapping Rain Water',
    difficulty: 'Hard',
    duration: 35,
    prompt: 'Compute how much water can be trapped between elevation bars.',
    problemStatement:
      'Given a non-negative integer array height where each element is bar width 1, compute how much water can be trapped after raining.',
    sampleInput: '[0,1,0,2,1,0,1,3,2,1,2,1]',
    sampleOutput: '6',
    evaluationLogic: [
      'Uses two pointers or stacks correctly',
      'Accumulates water units between taller boundaries',
      'Handles flat or empty terrain',
    ],
    starterByLanguage: {
      javascript: 'function trap(height) {\n  // Write your code here\n}\n',
      nodejs: 'function trap(height) {\n  // Write your code here\n}\nmodule.exports = { trap };\n',
      python: 'def trap(height):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int trap(int[] height) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function trap(height) {\n  if (!height.length) return 0;\n  let left = 0;\n  let right = height.length - 1;\n  let leftMax = 0;\n  let rightMax = 0;\n  let water = 0;\n  while (left < right) {\n    if (height[left] < height[right]) {\n      if (height[left] >= leftMax) leftMax = height[left];\n      else water += leftMax - height[left];\n      left += 1;\n    } else {\n      if (height[right] >= rightMax) rightMax = height[right];\n      else water += rightMax - height[right];\n      right -= 1;\n    }\n  }\n  return water;\n}\n',
      nodejs:
        'function trap(height) {\n  if (!height.length) return 0;\n  let left = 0;\n  let right = height.length - 1;\n  let leftMax = 0;\n  let rightMax = 0;\n  let water = 0;\n  while (left < right) {\n    if (height[left] < height[right]) {\n      if (height[left] >= leftMax) leftMax = height[left];\n      else water += leftMax - height[left];\n      left += 1;\n    } else {\n      if (height[right] >= rightMax) rightMax = height[right];\n      else water += rightMax - height[right];\n      right -= 1;\n    }\n  }\n  return water;\n}\nmodule.exports = { trap };\n',
      python:
        'def trap(height):\n    if not height:\n        return 0\n    left, right = 0, len(height) - 1\n    left_max = right_max = water = 0\n    while left < right:\n        if height[left] < height[right]:\n            if height[left] >= left_max:\n                left_max = height[left]\n            else:\n                water += left_max - height[left]\n            left += 1\n        else:\n            if height[right] >= right_max:\n                right_max = height[right]\n            else:\n                water += right_max - height[right]\n            right -= 1\n    return water\n',
      java:
        'class Solution {\n  public int trap(int[] height) {\n    if (height.length == 0) return 0;\n    int left = 0, right = height.length - 1;\n    int leftMax = 0, rightMax = 0, water = 0;\n    while (left < right) {\n      if (height[left] < height[right]) {\n        if (height[left] >= leftMax) leftMax = height[left];\n        else water += leftMax - height[left];\n        left++;\n      } else {\n        if (height[right] >= rightMax) rightMax = height[right];\n        else water += rightMax - height[right];\n        right--;\n      }\n    }\n    return water;\n  }\n}\n',
    },
  },
  {
    id: 'parse-query-string',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Parse Query String',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Parse a URL-style query string into key-value pairs.',
    problemStatement:
      'Given a string qs like "a=1&b=2&a=3" (no URL encoding), return a map/object of keys to string values. If a key appears more than once, the last value wins. Ignore empty keys. If qs is empty, return an empty map.',
    sampleInput: '"a=1&b=2&a=3"',
    sampleOutput: 'a=3,b=2 (map)',
    evaluationLogic: [
      'Splits on & and = correctly',
      'Last value wins for duplicate keys',
      'Handles empty input',
    ],
    starterByLanguage: {
      javascript: 'function parseQueryString(qs) {\n  // Write your code here\n}\n',
      nodejs:
        'function parseQueryString(qs) {\n  // Write your code here\n}\nmodule.exports = { parseQueryString };\n',
      python: 'def parse_query_string(qs):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.Map<String, String> parseQueryString(String qs) {\n    // Write your code here\n    return new java.util.HashMap<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function parseQueryString(qs) {\n  const out = {};\n  if (!qs) return out;\n  String(qs).split("&").forEach((pair) => {\n    const idx = pair.indexOf("=");\n    if (idx === -1) return;\n    const k = pair.slice(0, idx);\n    const v = pair.slice(idx + 1);\n    if (k) out[k] = v;\n  });\n  return out;\n}\n',
      nodejs:
        'function parseQueryString(qs) {\n  const out = {};\n  if (!qs) return out;\n  String(qs).split("&").forEach((pair) => {\n    const idx = pair.indexOf("=");\n    if (idx === -1) return;\n    const k = pair.slice(0, idx);\n    const v = pair.slice(idx + 1);\n    if (k) out[k] = v;\n  });\n  return out;\n}\nmodule.exports = { parseQueryString };\n',
      python:
        'def parse_query_string(qs):\n    out = {}\n    if not qs:\n        return out\n    for pair in str(qs).split("&"):\n        if "=" not in pair:\n            continue\n        k, v = pair.split("=", 1)\n        if k:\n            out[k] = v\n    return out\n',
      java:
        'class Solution {\n  public java.util.Map<String, String> parseQueryString(String qs) {\n    java.util.Map<String, String> out = new java.util.HashMap<>();\n    if (qs == null || qs.isEmpty()) return out;\n    for (String pair : qs.split("&")) {\n      int idx = pair.indexOf("=");\n      if (idx < 0) continue;\n      String k = pair.substring(0, idx);\n      String v = pair.substring(idx + 1);\n      if (!k.isEmpty()) out.put(k, v);\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'group-strings-by-first-char',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Group Strings by First Character',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Group strings by their first character.',
    problemStatement:
      'Given an array of non-empty strings, return a map from each first character to the list of strings that start with that character. Preserve the original order within each group.',
    sampleInput: '["apple","apricot","banana","cherry"]',
    sampleOutput: 'a:[apple,apricot], b:[banana], c:[cherry]',
    evaluationLogic: [
      'Uses first character as key',
      'Keeps stable ordering within buckets',
      'Skips or never receives empty strings per problem',
    ],
    starterByLanguage: {
      javascript: 'function groupByFirstChar(words) {\n  // Write your code here\n}\n',
      nodejs:
        'function groupByFirstChar(words) {\n  // Write your code here\n}\nmodule.exports = { groupByFirstChar };\n',
      python: 'def group_by_first_char(words):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.Map<String, java.util.List<String>> groupByFirstChar(String[] words) {\n    // Write your code here\n    return new java.util.LinkedHashMap<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function groupByFirstChar(words) {\n  const out = {};\n  for (const w of words) {\n    const k = w[0];\n    if (!out[k]) out[k] = [];\n    out[k].push(w);\n  }\n  return out;\n}\n',
      nodejs:
        'function groupByFirstChar(words) {\n  const out = {};\n  for (const w of words) {\n    const k = w[0];\n    if (!out[k]) out[k] = [];\n    out[k].push(w);\n  }\n  return out;\n}\nmodule.exports = { groupByFirstChar };\n',
      python:
        'def group_by_first_char(words):\n    out = {}\n    for w in words:\n        k = w[0]\n        out.setdefault(k, []).append(w)\n    return out\n',
      java:
        'class Solution {\n  public java.util.Map<String, java.util.List<String>> groupByFirstChar(String[] words) {\n    java.util.Map<String, java.util.List<String>> out = new java.util.LinkedHashMap<>();\n    for (String w : words) {\n      String k = w.substring(0, 1);\n      out.computeIfAbsent(k, kk -> new java.util.ArrayList<>()).add(w);\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'sum-nested-integers',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Sum Nested Integers',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Sum all integers in an arbitrarily nested list structure.',
    problemStatement:
      'Given a nested structure where each node is either an integer or a list of such nodes, return the sum of every integer in the structure.',
    sampleInput: '[1,[2,3],[4,[5]]]',
    sampleOutput: '15',
    evaluationLogic: ['Recurses or iterates through nesting', 'Handles empty lists', 'Sums all integers'],
    starterByLanguage: {
      javascript: 'function sumNested(node) {\n  // Write your code here\n}\n',
      nodejs: 'function sumNested(node) {\n  // Write your code here\n}\nmodule.exports = { sumNested };\n',
      python: 'def sum_nested(node):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int sumNested(Object node) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function sumNested(node) {\n  if (typeof node === "number") return node;\n  let s = 0;\n  for (const x of node) s += sumNested(x);\n  return s;\n}\n',
      nodejs:
        'function sumNested(node) {\n  if (typeof node === "number") return node;\n  let s = 0;\n  for (const x of node) s += sumNested(x);\n  return s;\n}\nmodule.exports = { sumNested };\n',
      python:
        'def sum_nested(node):\n    if isinstance(node, int):\n        return node\n    total = 0\n    for x in node:\n        total += sum_nested(x)\n    return total\n',
      java:
        'class Solution {\n  public int sumNested(Object node) {\n    if (node instanceof Integer) return (Integer) node;\n    int s = 0;\n    if (node instanceof java.util.List) {\n      for (Object o : (java.util.List<?>) node) s += sumNested(o);\n    }\n    return s;\n  }\n}\n',
    },
  },
  {
    id: 'first-duplicate-value',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'First Duplicate Value',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Return the first integer that appears twice (left-to-right).',
    problemStatement:
      'Given an integer array nums, return the first value that occurs more than once when scanning from the start. If no duplicate exists, return -1.',
    sampleInput: '[5,3,4,3,2]',
    sampleOutput: '3',
    evaluationLogic: [
      'Detects duplicates in scan order',
      'Returns -1 when all unique',
      'Uses memory proportional to seen values',
    ],
    starterByLanguage: {
      javascript: 'function firstDuplicate(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function firstDuplicate(nums) {\n  // Write your code here\n}\nmodule.exports = { firstDuplicate };\n',
      python: 'def first_duplicate(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int firstDuplicate(int[] nums) {\n    // Write your code here\n    return -1;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function firstDuplicate(nums) {\n  const seen = new Set();\n  for (const n of nums) {\n    if (seen.has(n)) return n;\n    seen.add(n);\n  }\n  return -1;\n}\n',
      nodejs:
        'function firstDuplicate(nums) {\n  const seen = new Set();\n  for (const n of nums) {\n    if (seen.has(n)) return n;\n    seen.add(n);\n  }\n  return -1;\n}\nmodule.exports = { firstDuplicate };\n',
      python:
        'def first_duplicate(nums):\n    seen = set()\n    for n in nums:\n        if n in seen:\n            return n\n        seen.add(n)\n    return -1\n',
      java:
        'class Solution {\n  public int firstDuplicate(int[] nums) {\n    java.util.Set<Integer> seen = new java.util.HashSet<>();\n    for (int n : nums) {\n      if (seen.contains(n)) return n;\n      seen.add(n);\n    }\n    return -1;\n  }\n}\n',
    },
  },
  {
    id: 'merge-two-sorted-arrays',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Merge Two Sorted Arrays',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Merge two sorted arrays into one sorted array.',
    problemStatement:
      'Given two integer arrays a and b sorted in non-decreasing order, return a new array containing all elements from both, sorted.',
    sampleInput: 'a=[1,3,5], b=[2,4,6]',
    sampleOutput: '[1,2,3,4,5,6]',
    evaluationLogic: [
      'Uses two-pointer merge',
      'Preserves non-decreasing order',
      'Handles empty inputs',
    ],
    starterByLanguage: {
      javascript: 'function mergeSorted(a, b) {\n  // Write your code here\n}\n',
      nodejs: 'function mergeSorted(a, b) {\n  // Write your code here\n}\nmodule.exports = { mergeSorted };\n',
      python: 'def merge_sorted(a, b):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int[] mergeSorted(int[] a, int[] b) {\n    // Write your code here\n    return new int[0];\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function mergeSorted(a, b) {\n  const out = [];\n  let i = 0;\n  let j = 0;\n  while (i < a.length && j < b.length) {\n    if (a[i] <= b[j]) out.push(a[i++]);\n    else out.push(b[j++]);\n  }\n  while (i < a.length) out.push(a[i++]);\n  while (j < b.length) out.push(b[j++]);\n  return out;\n}\n',
      nodejs:
        'function mergeSorted(a, b) {\n  const out = [];\n  let i = 0;\n  let j = 0;\n  while (i < a.length && j < b.length) {\n    if (a[i] <= b[j]) out.push(a[i++]);\n    else out.push(b[j++]);\n  }\n  while (i < a.length) out.push(a[i++]);\n  while (j < b.length) out.push(b[j++]);\n  return out;\n}\nmodule.exports = { mergeSorted };\n',
      python:
        'def merge_sorted(a, b):\n    i, j = 0, 0\n    out = []\n    while i < len(a) and j < len(b):\n        if a[i] <= b[j]:\n            out.append(a[i])\n            i += 1\n        else:\n            out.append(b[j])\n            j += 1\n    out.extend(a[i:])\n    out.extend(b[j:])\n    return out\n',
      java:
        'class Solution {\n  public int[] mergeSorted(int[] a, int[] b) {\n    int[] out = new int[a.length + b.length];\n    int i = 0, j = 0, k = 0;\n    while (i < a.length && j < b.length) {\n      if (a[i] <= b[j]) out[k++] = a[i++];\n      else out[k++] = b[j++];\n    }\n    while (i < a.length) out[k++] = a[i++];\n    while (j < b.length) out[k++] = b[j++];\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'word-frequency-count',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Word Frequency Count',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Count how often each word appears in a string (case-insensitive).',
    problemStatement:
      'Given a string text, split on whitespace (one or more spaces, tabs, or newlines), compare words case-insensitively, and return a map of lowercase words to counts.',
    sampleInput: '"Cat cat DOG cat"',
    sampleOutput: 'cat:3, dog:1',
    evaluationLogic: [
      'Normalizes case for keys',
      'Splits on general whitespace',
      'Increments counts correctly',
    ],
    starterByLanguage: {
      javascript: 'function wordFrequency(text) {\n  // Write your code here\n}\n',
      nodejs:
        'function wordFrequency(text) {\n  // Write your code here\n}\nmodule.exports = { wordFrequency };\n',
      python: 'def word_frequency(text):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.Map<String, Integer> wordFrequency(String text) {\n    // Write your code here\n    return new java.util.HashMap<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function wordFrequency(text) {\n  const out = {};\n  if (!text || !text.trim()) return out;\n  const parts = text.trim().split(/\\s+/);\n  for (const w of parts) {\n    const k = w.toLowerCase();\n    out[k] = (out[k] || 0) + 1;\n  }\n  return out;\n}\n',
      nodejs:
        'function wordFrequency(text) {\n  const out = {};\n  if (!text || !text.trim()) return out;\n  const parts = text.trim().split(/\\s+/);\n  for (const w of parts) {\n    const k = w.toLowerCase();\n    out[k] = (out[k] || 0) + 1;\n  }\n  return out;\n}\nmodule.exports = { wordFrequency };\n',
      python:
        'def word_frequency(text):\n    import re\n    out = {}\n    for w in re.split(r"\\s+", text.strip()):\n        if not w:\n            continue\n        k = w.lower()\n        out[k] = out.get(k, 0) + 1\n    return out\n',
      java:
        'class Solution {\n  public java.util.Map<String, Integer> wordFrequency(String text) {\n    java.util.Map<String, Integer> out = new java.util.HashMap<>();\n    if (text == null || text.trim().isEmpty()) return out;\n    for (String w : text.trim().split("\\\\s+")) {\n      if (w.isEmpty()) continue;\n      String k = w.toLowerCase();\n      out.put(k, out.getOrDefault(k, 0) + 1);\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'valid-brackets',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Validate Bracket Nesting',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Check that (), [], and {} brackets are correctly nested and closed.',
    problemStatement:
      'Given a string s containing only "(", ")", "[", "]", "{", and "}", return true if the bracket ordering is valid; otherwise false.',
    sampleInput: '"{[()]}"',
    sampleOutput: 'true',
    evaluationLogic: [
      'Uses stack or equivalent logic',
      'Matches closing brackets to the correct opener',
      'Rejects premature closers and leftover openers',
    ],
    starterByLanguage: {
      javascript: 'function isValidBrackets(s) {\n  // Write your code here\n}\n',
      nodejs:
        'function isValidBrackets(s) {\n  // Write your code here\n}\nmodule.exports = { isValidBrackets };\n',
      python: 'def is_valid_brackets(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public boolean isValidBrackets(String s) {\n    // Write your code here\n    return false;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function isValidBrackets(s) {\n  const stack = [];\n  const pair = { ")": "(", "]": "[", "}": "{" };\n  for (const ch of s) {\n    if ("([{".includes(ch)) stack.push(ch);\n    else {\n      if (!stack.length || stack.pop() !== pair[ch]) return false;\n    }\n  }\n  return stack.length === 0;\n}\n',
      nodejs:
        'function isValidBrackets(s) {\n  const stack = [];\n  const pair = { ")": "(", "]": "[", "}": "{" };\n  for (const ch of s) {\n    if ("([{".includes(ch)) stack.push(ch);\n    else {\n      if (!stack.length || stack.pop() !== pair[ch]) return false;\n    }\n  }\n  return stack.length === 0;\n}\nmodule.exports = { isValidBrackets };\n',
      python:
        'def is_valid_brackets(s):\n    stack = []\n    pair = {")": "(", "]": "[", "}": "{"}\n    openers = set("([{")\n    for ch in s:\n        if ch in openers:\n            stack.append(ch)\n        else:\n            if not stack or stack.pop() != pair.get(ch):\n                return False\n    return len(stack) == 0\n',
      java:
        'class Solution {\n  public boolean isValidBrackets(String s) {\n    java.util.Deque<Character> stack = new java.util.ArrayDeque<>();\n    for (char ch : s.toCharArray()) {\n      if (ch == \'(\' || ch == \'[\' || ch == \'{\') stack.push(ch);\n      else {\n        if (stack.isEmpty()) return false;\n        char o = stack.pop();\n        if (ch == \')\' && o != \'(\') return false;\n        if (ch == \']\' && o != \'[\') return false;\n        if (ch == \'}\' && o != \'{\') return false;\n      }\n    }\n    return stack.isEmpty();\n  }\n}\n',
    },
  },
  {
    id: 'longest-consecutive-subsequence',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Longest Consecutive Sequence',
    difficulty: 'Hard',
    duration: 30,
    prompt: 'Find the longest run of consecutive integers in an unsorted array.',
    problemStatement:
      'Given an unsorted array of integers nums, return the length of the longest consecutive elements sequence. Runs are formed by integers differing by 1.',
    sampleInput: '[100,4,200,1,3,2]',
    sampleOutput: '4',
    evaluationLogic: [
      'Runs in O(n) expected or average time with a set/map',
      'Does not require sorting the full array',
      'Handles duplicates and negatives',
    ],
    starterByLanguage: {
      javascript: 'function longestConsecutive(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function longestConsecutive(nums) {\n  // Write your code here\n}\nmodule.exports = { longestConsecutive };\n',
      python: 'def longest_consecutive(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int longestConsecutive(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function longestConsecutive(nums) {\n  const set = new Set(nums);\n  let best = 0;\n  for (const n of set) {\n    if (set.has(n - 1)) continue;\n    let len = 1;\n    while (set.has(n + len)) len += 1;\n    best = Math.max(best, len);\n  }\n  return best;\n}\n',
      nodejs:
        'function longestConsecutive(nums) {\n  const set = new Set(nums);\n  let best = 0;\n  for (const n of set) {\n    if (set.has(n - 1)) continue;\n    let len = 1;\n    while (set.has(n + len)) len += 1;\n    best = Math.max(best, len);\n  }\n  return best;\n}\nmodule.exports = { longestConsecutive };\n',
      python:
        'def longest_consecutive(nums):\n    s = set(nums)\n    best = 0\n    for n in s:\n        if n - 1 in s:\n            continue\n        length = 1\n        while n + length in s:\n            length += 1\n        best = max(best, length)\n    return best\n',
      java:
        'class Solution {\n  public int longestConsecutive(int[] nums) {\n    java.util.Set<Integer> set = new java.util.HashSet<>();\n    for (int n : nums) set.add(n);\n    int best = 0;\n    for (int n : set) {\n      if (set.contains(n - 1)) continue;\n      int len = 1;\n      while (set.contains(n + len)) len++;\n      best = Math.max(best, len);\n    }\n    return best;\n  }\n}\n',
    },
  },
  {
    id: 'product-of-array-except-self',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Product of Array Except Self',
    difficulty: 'Hard',
    duration: 30,
    prompt: 'Return an array where each index is the product of all other elements.',
    problemStatement:
      'Given an integer array nums, return an array answer such that answer[i] is the product of all elements except nums[i]. Solve without division. Time O(n), extra space O(1) excluding output.',
    sampleInput: '[1,2,3,4]',
    sampleOutput: '[24,12,8,6]',
    evaluationLogic: [
      'Builds prefix and suffix products',
      'Avoids division operator',
      'Handles zeros consistently',
    ],
    starterByLanguage: {
      javascript: 'function productExceptSelf(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function productExceptSelf(nums) {\n  // Write your code here\n}\nmodule.exports = { productExceptSelf };\n',
      python: 'def product_except_self(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int[] productExceptSelf(int[] nums) {\n    // Write your code here\n    return new int[0];\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function productExceptSelf(nums) {\n  const out = new Array(nums.length).fill(1);\n  let p = 1;\n  for (let i = 0; i < nums.length; i += 1) {\n    out[i] *= p;\n    p *= nums[i];\n  }\n  p = 1;\n  for (let i = nums.length - 1; i >= 0; i -= 1) {\n    out[i] *= p;\n    p *= nums[i];\n  }\n  return out;\n}\n',
      nodejs:
        'function productExceptSelf(nums) {\n  const out = new Array(nums.length).fill(1);\n  let p = 1;\n  for (let i = 0; i < nums.length; i += 1) {\n    out[i] *= p;\n    p *= nums[i];\n  }\n  p = 1;\n  for (let i = nums.length - 1; i >= 0; i -= 1) {\n    out[i] *= p;\n    p *= nums[i];\n  }\n  return out;\n}\nmodule.exports = { productExceptSelf };\n',
      python:
        'def product_except_self(nums):\n    n = len(nums)\n    out = [1] * n\n    p = 1\n    for i in range(n):\n        out[i] *= p\n        p *= nums[i]\n    p = 1\n    for i in range(n - 1, -1, -1):\n        out[i] *= p\n        p *= nums[i]\n    return out\n',
      java:
        'class Solution {\n  public int[] productExceptSelf(int[] nums) {\n    int n = nums.length;\n    int[] out = new int[n];\n    java.util.Arrays.fill(out, 1);\n    int p = 1;\n    for (int i = 0; i < n; i++) {\n      out[i] *= p;\n      p *= nums[i];\n    }\n    p = 1;\n    for (int i = n - 1; i >= 0; i--) {\n      out[i] *= p;\n      p *= nums[i];\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'daily-temperatures',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Daily Temperatures (Warmer Day Wait)',
    difficulty: 'Hard',
    duration: 35,
    prompt: 'For each day, return how many days you wait until a warmer temperature.',
    problemStatement:
      'Given an array temperatures where temperatures[i] is the temperature on day i, return an array answer of the same length where answer[i] is the number of days until a strictly higher temperature, or 0 if none.',
    sampleInput: '[73,74,75,71,69,72,76,73]',
    sampleOutput: '[1,1,4,2,1,1,0,0]',
    evaluationLogic: [
      'Uses a decreasing stack or equivalent in O(n)',
      'Handles plateaus correctly',
      'Produces correct wait counts',
    ],
    starterByLanguage: {
      javascript: 'function dailyTemperatures(temps) {\n  // Write your code here\n}\n',
      nodejs:
        'function dailyTemperatures(temps) {\n  // Write your code here\n}\nmodule.exports = { dailyTemperatures };\n',
      python: 'def daily_temperatures(temps):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int[] dailyTemperatures(int[] temps) {\n    // Write your code here\n    return new int[0];\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function dailyTemperatures(temps) {\n  const n = temps.length;\n  const ans = new Array(n).fill(0);\n  const st = [];\n  for (let i = 0; i < n; i += 1) {\n    while (st.length && temps[i] > temps[st[st.length - 1]]) {\n      const j = st.pop();\n      ans[j] = i - j;\n    }\n    st.push(i);\n  }\n  return ans;\n}\n',
      nodejs:
        'function dailyTemperatures(temps) {\n  const n = temps.length;\n  const ans = new Array(n).fill(0);\n  const st = [];\n  for (let i = 0; i < n; i += 1) {\n    while (st.length && temps[i] > temps[st[st.length - 1]]) {\n      const j = st.pop();\n      ans[j] = i - j;\n    }\n    st.push(i);\n  }\n  return ans;\n}\nmodule.exports = { dailyTemperatures };\n',
      python:
        'def daily_temperatures(temps):\n    n = len(temps)\n    ans = [0] * n\n    stack = []\n    for i, t in enumerate(temps):\n        while stack and t > temps[stack[-1]]:\n            j = stack.pop()\n            ans[j] = i - j\n        stack.append(i)\n    return ans\n',
      java:
        'class Solution {\n  public int[] dailyTemperatures(int[] temps) {\n    int n = temps.length;\n    int[] ans = new int[n];\n    java.util.Deque<Integer> st = new java.util.ArrayDeque<>();\n    for (int i = 0; i < n; i++) {\n      while (!st.isEmpty() && temps[i] > temps[st.peek()]) {\n        int j = st.pop();\n        ans[j] = i - j;\n      }\n      st.push(i);\n    }\n    return ans;\n  }\n}\n',
    },
  },
  {
    id: 'first-non-repeating-character',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'First Non-Repeating Character',
    difficulty: 'Medium',
    duration: 25,
    prompt: 'Return the first character that appears exactly once, scanned left to right.',
    problemStatement:
      'Given a string s, consider characters in left-to-right order. Return the first character whose total count in s is exactly 1. If no such character exists (empty string, or every character repeats), return an empty string. Letters are case-sensitive.',
    sampleInput: '"loveleetcode"',
    sampleOutput: '"v"',
    evaluationLogic: [
      'Counts occurrences of each character',
      'Second pass respects original scan order',
      'Returns empty string when none qualify',
    ],
    starterByLanguage: {
      javascript: 'function firstNonRepeating(s) {\n  // Write your code here\n}\n',
      nodejs:
        'function firstNonRepeating(s) {\n  // Write your code here\n}\nmodule.exports = { firstNonRepeating };\n',
      python: 'def first_non_repeating(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String firstNonRepeating(String s) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function firstNonRepeating(s) {\n  const count = {};\n  for (let i = 0; i < s.length; i += 1) {\n    const ch = s[i];\n    count[ch] = (count[ch] || 0) + 1;\n  }\n  for (let i = 0; i < s.length; i += 1) {\n    if (count[s[i]] === 1) return s[i];\n  }\n  return "";\n}\n',
      nodejs:
        'function firstNonRepeating(s) {\n  const count = {};\n  for (let i = 0; i < s.length; i += 1) {\n    const ch = s[i];\n    count[ch] = (count[ch] || 0) + 1;\n  }\n  for (let i = 0; i < s.length; i += 1) {\n    if (count[s[i]] === 1) return s[i];\n  }\n  return "";\n}\nmodule.exports = { firstNonRepeating };\n',
      python:
        'def first_non_repeating(s):\n    count = {}\n    for ch in s:\n        count[ch] = count.get(ch, 0) + 1\n    for ch in s:\n        if count[ch] == 1:\n            return ch\n    return ""\n',
      java:
        'class Solution {\n  public String firstNonRepeating(String s) {\n    java.util.Map<Character, Integer> count = new java.util.HashMap<>();\n    for (char ch : s.toCharArray()) {\n      count.put(ch, count.getOrDefault(ch, 0) + 1);\n    }\n    for (char ch : s.toCharArray()) {\n      if (count.get(ch) == 1) return String.valueOf(ch);\n    }\n    return "";\n  }\n}\n',
    },
  },
  {
    id: 'find-missing-number-no-sort',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Find Missing Number (Without Sorting)',
    difficulty: 'Medium',
    duration: 20,
    prompt: 'Find the single missing integer in range [0..n] without sorting.',
    problemStatement:
      'Given an array nums of n distinct integers, each in the inclusive range [0, n], exactly one integer in that range is missing. The array length is n. Return the missing integer. Do not sort the array; use O(n) time and O(1) extra space.',
    sampleInput: '[3,0,1]',
    sampleOutput: '2',
    evaluationLogic: [
      'Uses sum or XOR in linear time',
      'Does not mutate input with a full sort',
      'Handles n = 1 and larger ranges',
    ],
    starterByLanguage: {
      javascript: 'function missingNumber(nums) {\n  // Write your code here\n}\n',
      nodejs: 'function missingNumber(nums) {\n  // Write your code here\n}\nmodule.exports = { missingNumber };\n',
      python: 'def missing_number(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int missingNumber(int[] nums) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function missingNumber(nums) {\n  const n = nums.length;\n  let x = 0;\n  for (let i = 0; i < n; i += 1) x ^= nums[i] ^ i;\n  return x ^ n;\n}\n',
      nodejs:
        'function missingNumber(nums) {\n  const n = nums.length;\n  let x = 0;\n  for (let i = 0; i < n; i += 1) x ^= nums[i] ^ i;\n  return x ^ n;\n}\nmodule.exports = { missingNumber };\n',
      python:
        'def missing_number(nums):\n    n = len(nums)\n    x = 0\n    for i, v in enumerate(nums):\n        x ^= v ^ i\n    return x ^ n\n',
      java:
        'class Solution {\n  public int missingNumber(int[] nums) {\n    int n = nums.length;\n    int x = 0;\n    for (int i = 0; i < n; i++) {\n      x ^= nums[i] ^ i;\n    }\n    return x ^ n;\n  }\n}\n',
    },
  },
  {
    id: 'flatten-nested-object-api',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Flatten Nested Object (API / Config)',
    difficulty: 'Medium',
    duration: 30,
    prompt: 'Flatten a nested object into dot-key paths like config APIs use.',
    problemStatement:
      'Given a nested plain object (dictionary) where each value is either a primitive (string, number, boolean, or null) or another nested object of the same kind, return a single-level object: each key is the dot-separated path from the root (e.g. user.address.city), and each value is the leaf primitive. Do not flatten arrays in this problem; you may assume no arrays appear in the input.\n\nExample input (conceptual): {"user":{"id":42,"active":false},"region":"us-east"}\nExample output: {"user.id":42,"user.active":false,"region":"us-east"}',
    sampleInput: '{"user":{"id":42,"active":false},"region":"us-east"}',
    sampleOutput: '{"user.id":42,"user.active":false,"region":"us-east"}',
    evaluationLogic: [
      'Recurses into nested objects only',
      'Builds dot paths correctly',
      'Preserves primitive leaf values',
    ],
    starterByLanguage: {
      javascript: 'function flattenNestedObject(obj) {\n  // Write your code here\n}\n',
      nodejs:
        'function flattenNestedObject(obj) {\n  // Write your code here\n}\nmodule.exports = { flattenNestedObject };\n',
      python: 'def flatten_nested_object(obj):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.Map<String, Object> flattenNestedObject(java.util.Map<String, Object> obj) {\n    // Write your code here\n    return new java.util.LinkedHashMap<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function flattenNestedObject(obj) {\n  const out = {};\n  function walk(node, prefix) {\n    if (node === null || typeof node !== "object" || Array.isArray(node)) return;\n    for (const k of Object.keys(node)) {\n      const v = node[k];\n      const key = prefix ? prefix + "." + k : k;\n      if (v !== null && typeof v === "object" && !Array.isArray(v)) walk(v, key);\n      else out[key] = v;\n    }\n  }\n  walk(obj, "");\n  return out;\n}\n',
      nodejs:
        'function flattenNestedObject(obj) {\n  const out = {};\n  function walk(node, prefix) {\n    if (node === null || typeof node !== "object" || Array.isArray(node)) return;\n    for (const k of Object.keys(node)) {\n      const v = node[k];\n      const key = prefix ? prefix + "." + k : k;\n      if (v !== null && typeof v === "object" && !Array.isArray(v)) walk(v, key);\n      else out[key] = v;\n    }\n  }\n  walk(obj, "");\n  return out;\n}\nmodule.exports = { flattenNestedObject };\n',
      python:
        'def flatten_nested_object(obj):\n    out = {}\n\n    def walk(node, prefix):\n        if not isinstance(node, dict):\n            return\n        for k, v in node.items():\n            key = f"{prefix}.{k}" if prefix else k\n            if isinstance(v, dict):\n                walk(v, key)\n            else:\n                out[key] = v\n\n    walk(obj, "")\n    return out\n',
      java:
        'class Solution {\n  public java.util.Map<String, Object> flattenNestedObject(java.util.Map<String, Object> obj) {\n    java.util.Map<String, Object> out = new java.util.LinkedHashMap<>();\n    walk(obj, "", out);\n    return out;\n  }\n  private void walk(java.util.Map<String, Object> node, String prefix, java.util.Map<String, Object> out) {\n    if (node == null) return;\n    for (java.util.Map.Entry<String, Object> e : node.entrySet()) {\n      String k = e.getKey();\n      Object v = e.getValue();\n      String key = prefix.isEmpty() ? k : prefix + "." + k;\n      if (v instanceof java.util.Map) {\n        @SuppressWarnings("unchecked")\n        java.util.Map<String, Object> child = (java.util.Map<String, Object>) v;\n        walk(child, key, out);\n      } else {\n        out.put(key, v);\n      }\n    }\n  }\n}\n',
    },
  },
  {
    id: 'debounce-function',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Debounce Function',
    difficulty: 'Hard',
    duration: 35,
    prompt: 'Return a debounced wrapper: invoke the inner function only after quiet period.',
    problemStatement:
      'Implement debounce(fn, delayMs) that returns a new function wrapped. Each time the wrapper is called with arguments, the scheduled call to fn is reset: fn must run only after delayMs milliseconds have passed without the wrapper being called again (last call wins). Use the same this-binding as the invocation that fires. Use setTimeout/clearTimeout (JavaScript/Node), threading.Timer (Python), or Timer/TimerTask (Java) as appropriate; delayMs is a non-negative number.',
    sampleInput: 'debounce(fn, 150): call wrapped("a"), call wrapped("b") 40ms later; fn receives "b" once after 150ms idle',
    sampleOutput: 'Last arguments win; single fn invocation after quiet period',
    evaluationLogic: [
      'Resets timer on repeated calls within window',
      'Passes latest arguments to fn',
      'Uses timer/cancel pattern appropriate to language',
    ],
    starterByLanguage: {
      javascript: 'function debounce(fn, delayMs) {\n  // Write your code here\n}\n',
      nodejs: 'function debounce(fn, delayMs) {\n  // Write your code here\n}\nmodule.exports = { debounce };\n',
      python: 'def debounce(fn, delay_ms):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.function.IntConsumer debounce(java.util.function.IntConsumer fn, long delayMs) {\n    // Write your code here; return wrapped consumer\n    return (x) -> {};\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function debounce(fn, delayMs) {\n  let t = null;\n  return function debounced(...args) {\n    const ctx = this;\n    if (t) clearTimeout(t);\n    t = setTimeout(() => {\n      t = null;\n      fn.apply(ctx, args);\n    }, delayMs);\n  };\n}\n',
      nodejs:
        'function debounce(fn, delayMs) {\n  let t = null;\n  return function debounced(...args) {\n    const ctx = this;\n    if (t) clearTimeout(t);\n    t = setTimeout(() => {\n      t = null;\n      fn.apply(ctx, args);\n    }, delayMs);\n  };\n}\nmodule.exports = { debounce };\n',
      python:
        'import threading\n\n\ndef debounce(fn, delay_ms):\n    lock = threading.Lock()\n    timer = {"t": None}\n\n    def wrapped(*args, **kwargs):\n        def call():\n            fn(*args, **kwargs)\n\n        with lock:\n            if timer["t"] is not None:\n                timer["t"].cancel()\n            timer["t"] = threading.Timer(delay_ms / 1000.0, call)\n            timer["t"].start()\n\n    return wrapped\n',
      java:
        'class Solution {\n  public java.util.function.IntConsumer debounce(java.util.function.IntConsumer fn, long delayMs) {\n    final java.util.Timer timer = new java.util.Timer(true);\n    final java.util.concurrent.atomic.AtomicReference<java.util.TimerTask> pending =\n        new java.util.concurrent.atomic.AtomicReference<>();\n    return (int x) -> {\n      java.util.TimerTask prev = pending.getAndSet(null);\n      if (prev != null) prev.cancel();\n      java.util.TimerTask task =\n          new java.util.TimerTask() {\n            public void run() {\n              fn.accept(x);\n            }\n          };\n      pending.set(task);\n      timer.schedule(task, delayMs);\n    };\n  }\n}\n',
    },
  },
  {
    id: 'group-anagrams',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Group Anagrams',
    difficulty: 'Medium',
    duration: 28,
    prompt: 'Group strings that are anagrams of each other.',
    problemStatement:
      'Given an array of strings strs, group the anagrams together. An anagram is formed by rearranging letters of another string using all letters exactly once (case-sensitive). The order of groups in the result is not specified; the order of strings inside each group is not specified. Return an array of groups (each group is an array of strings).',
    sampleInput: '["eat","tea","tan","ate","nat","bat"]',
    sampleOutput: '[["bat"],["nat","tan"],["ate","eat","tea"]]  (groups equivalent up to permutation)',
    evaluationLogic: [
      'Uses character frequency or sorted key for bucketing',
      'All anagrams land in same group',
      'Each input string appears exactly once in output',
    ],
    starterByLanguage: {
      javascript: 'function groupAnagrams(strs) {\n  // Write your code here\n}\n',
      nodejs: 'function groupAnagrams(strs) {\n  // Write your code here\n}\nmodule.exports = { groupAnagrams };\n',
      python: 'def group_anagrams(strs):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.List<java.util.List<String>> groupAnagrams(String[] strs) {\n    // Write your code here\n    return new java.util.ArrayList<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function groupAnagrams(strs) {\n  const map = new Map();\n  for (const w of strs) {\n    const key = w.split("").sort().join("");\n    if (!map.has(key)) map.set(key, []);\n    map.get(key).push(w);\n  }\n  return Array.from(map.values());\n}\n',
      nodejs:
        'function groupAnagrams(strs) {\n  const map = new Map();\n  for (const w of strs) {\n    const key = w.split("").sort().join("");\n    if (!map.has(key)) map.set(key, []);\n    map.get(key).push(w);\n  }\n  return Array.from(map.values());\n}\nmodule.exports = { groupAnagrams };\n',
      python:
        'def group_anagrams(strs):\n    buckets = {}\n    for w in strs:\n        key = "".join(sorted(w))\n        buckets.setdefault(key, []).append(w)\n    return list(buckets.values())\n',
      java:
        'class Solution {\n  public java.util.List<java.util.List<String>> groupAnagrams(String[] strs) {\n    java.util.Map<String, java.util.List<String>> map = new java.util.HashMap<>();\n    for (String w : strs) {\n      char[] ca = w.toCharArray();\n      java.util.Arrays.sort(ca);\n      String key = new String(ca);\n      map.computeIfAbsent(key, k -> new java.util.ArrayList<>()).add(w);\n    }\n    return new java.util.ArrayList<>(map.values());\n  }\n}\n',
    },
  },
  {
    id: 'duplicate-value-indices',
    pack: CODING_TEMPLATE_PACK.BACKEND,
    title: 'Duplicate Values and Their Indices',
    difficulty: 'Medium',
    duration: 25,
    prompt: 'List every value that appears more than once and all indices where it occurs.',
    problemStatement:
      'Given an integer array nums, return a map/object from each duplicate value (appears 2+ times) to an array of all 0-based indices where that value occurs, sorted in ascending index order. Values that appear only once must not appear in the result. If nothing repeats, return an empty map/object.',
    sampleInput: '[1,2,3,2,1,3]',
    sampleOutput: '{"1":[0,4],"2":[1,3],"3":[2,5]}',
    evaluationLogic: [
      'Collects all index positions per value',
      'Includes only values with count > 1',
      'Index lists sorted ascending',
    ],
    starterByLanguage: {
      javascript: 'function duplicateValueIndices(nums) {\n  // Write your code here\n}\n',
      nodejs:
        'function duplicateValueIndices(nums) {\n  // Write your code here\n}\nmodule.exports = { duplicateValueIndices };\n',
      python: 'def duplicate_value_indices(nums):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.Map<Integer, java.util.List<Integer>> duplicateValueIndices(int[] nums) {\n    // Write your code here\n    return new java.util.LinkedHashMap<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function duplicateValueIndices(nums) {\n  const pos = new Map();\n  for (let i = 0; i < nums.length; i += 1) {\n    const n = nums[i];\n    if (!pos.has(n)) pos.set(n, []);\n    pos.get(n).push(i);\n  }\n  const out = {};\n  for (const [k, arr] of pos) {\n    if (arr.length > 1) out[k] = arr;\n  }\n  return out;\n}\n',
      nodejs:
        'function duplicateValueIndices(nums) {\n  const pos = new Map();\n  for (let i = 0; i < nums.length; i += 1) {\n    const n = nums[i];\n    if (!pos.has(n)) pos.set(n, []);\n    pos.get(n).push(i);\n  }\n  const out = {};\n  for (const [k, arr] of pos) {\n    if (arr.length > 1) out[k] = arr;\n  }\n  return out;\n}\nmodule.exports = { duplicateValueIndices };\n',
      python:
        'def duplicate_value_indices(nums):\n    from collections import defaultdict\n    pos = defaultdict(list)\n    for i, n in enumerate(nums):\n        pos[n].append(i)\n    return {k: v for k, v in sorted(pos.items()) if len(v) > 1}\n',
      java:
        'class Solution {\n  public java.util.Map<Integer, java.util.List<Integer>> duplicateValueIndices(int[] nums) {\n    java.util.Map<Integer, java.util.List<Integer>> pos = new java.util.TreeMap<>();\n    for (int i = 0; i < nums.length; i++) {\n      pos.computeIfAbsent(nums[i], k -> new java.util.ArrayList<>()).add(i);\n    }\n    java.util.Map<Integer, java.util.List<Integer>> out = new java.util.LinkedHashMap<>();\n    for (java.util.Map.Entry<Integer, java.util.List<Integer>> e : pos.entrySet()) {\n      if (e.getValue().size() > 1) out.put(e.getKey(), e.getValue());\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'slugify-string',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Slugify String',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Turn a title into a URL-friendly slug.',
    problemStatement:
      'Given a string s, return a lowercase slug: trim, replace spaces with "-", remove characters that are not letters, digits, or hyphen, and collapse multiple hyphens into one. Leading or trailing hyphens should be removed.',
    sampleInput: '"  Hello--World!  "',
    sampleOutput: '"hello-world"',
    evaluationLogic: [
      'Lowercases output',
      'Strips invalid characters',
      'Normalizes hyphen runs',
    ],
    starterByLanguage: {
      javascript: 'function slugify(s) {\n  // Write your code here\n}\n',
      nodejs: 'function slugify(s) {\n  // Write your code here\n}\nmodule.exports = { slugify };\n',
      python: 'def slugify(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String slugify(String s) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function slugify(s) {\n  let t = String(s || "")\n    .trim()\n    .toLowerCase()\n    .replace(/[^a-z0-9]+/g, "-")\n    .replace(/^-+|-+$/g, "");\n  return t;\n}\n',
      nodejs:
        'function slugify(s) {\n  let t = String(s || "")\n    .trim()\n    .toLowerCase()\n    .replace(/[^a-z0-9]+/g, "-")\n    .replace(/^-+|-+$/g, "");\n  return t;\n}\nmodule.exports = { slugify };\n',
      python:
        'import re\n\ndef slugify(s):\n    t = re.sub(r"[^a-z0-9]+", "-", str(s).strip().lower())\n    return t.strip("-")\n',
      java:
        'class Solution {\n  public String slugify(String s) {\n    if (s == null) s = "";\n    String low = s.trim().toLowerCase();\n    StringBuilder b = new StringBuilder();\n    boolean prevHyphen = false;\n    for (char ch : low.toCharArray()) {\n      if ((ch >= \'a\' && ch <= \'z\') || (ch >= \'0\' && ch <= \'9\')) {\n        b.append(ch);\n        prevHyphen = false;\n      } else if (!prevHyphen && b.length() > 0) {\n        b.append("-");\n        prevHyphen = true;\n      }\n    }\n    String out = b.toString();\n    if (out.endsWith("-")) out = out.substring(0, out.length() - 1);\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'truncate-with-ellipsis',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Truncate with Ellipsis',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Shorten a string to max length including ellipsis.',
    problemStatement:
      'Given a string s and integer maxLen (maxLen >= 3), if s has more than maxLen characters, return the first maxLen - 3 characters followed by "...". Otherwise return s unchanged.',
    sampleInput: 's, maxLen = "Hello World", 8',
    sampleOutput: '"He..."',
    evaluationLogic: [
      'Uses maxLen - 3 before ellipsis when truncating',
      'Returns original when within limit',
      'Assumes maxLen >= 3',
    ],
    starterByLanguage: {
      javascript: 'function truncateEllipsis(s, maxLen) {\n  // Write your code here\n}\n',
      nodejs:
        'function truncateEllipsis(s, maxLen) {\n  // Write your code here\n}\nmodule.exports = { truncateEllipsis };\n',
      python: 'def truncate_ellipsis(s, max_len):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String truncateEllipsis(String s, int maxLen) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function truncateEllipsis(s, maxLen) {\n  if (s.length <= maxLen) return s;\n  return s.slice(0, maxLen - 3) + "...";\n}\n',
      nodejs:
        'function truncateEllipsis(s, maxLen) {\n  if (s.length <= maxLen) return s;\n  return s.slice(0, maxLen - 3) + "...";\n}\nmodule.exports = { truncateEllipsis };\n',
      python:
        'def truncate_ellipsis(s, max_len):\n    s = str(s)\n    if len(s) <= max_len:\n        return s\n    return s[: max_len - 3] + "..."\n',
      java:
        'class Solution {\n  public String truncateEllipsis(String s, int maxLen) {\n    if (s.length() <= maxLen) return s;\n    return s.substring(0, maxLen - 3) + "...";\n  }\n}\n',
    },
  },
  {
    id: 'flatten-nested-array',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Flatten Nested Array',
    difficulty: 'Hard',
    duration: 25,
    prompt: 'Flatten a deeply nested list of integers into one array.',
    problemStatement:
      'Given a nested list where each element is either an integer or a nested list of the same kind, return a flat array of integers in depth-first order.',
    sampleInput: '[[1,2],[3,[4,5]]]',
    sampleOutput: '[1,2,3,4,5]',
    evaluationLogic: [
      'Flattens arbitrary depth',
      'Preserves depth-first order',
      'Handles empty inner lists',
    ],
    starterByLanguage: {
      javascript: 'function flattenNested(node) {\n  // Write your code here\n}\n',
      nodejs: 'function flattenNested(node) {\n  // Write your code here\n}\nmodule.exports = { flattenNested };\n',
      python: 'def flatten_nested(node):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public java.util.List<Integer> flattenNested(Object node) {\n    // Write your code here\n    return new java.util.ArrayList<>();\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function flattenNested(node) {\n  if (typeof node === "number") return [node];\n  const out = [];\n  for (const x of node) out.push(...flattenNested(x));\n  return out;\n}\n',
      nodejs:
        'function flattenNested(node) {\n  if (typeof node === "number") return [node];\n  const out = [];\n  for (const x of node) out.push(...flattenNested(x));\n  return out;\n}\nmodule.exports = { flattenNested };\n',
      python:
        'def flatten_nested(node):\n    if isinstance(node, int):\n        return [node]\n    out = []\n    for x in node:\n        out.extend(flatten_nested(x))\n    return out\n',
      java:
        'class Solution {\n  public java.util.List<Integer> flattenNested(Object node) {\n    java.util.List<Integer> out = new java.util.ArrayList<>();\n    if (node instanceof Integer) {\n      out.add((Integer) node);\n      return out;\n    }\n    if (node instanceof java.util.List) {\n      for (Object o : (java.util.List<?>) node) out.addAll(flattenNested(o));\n    }\n    return out;\n  }\n}\n',
    },
  },
  {
    id: 'palindrome-alphanumeric',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Palindrome (Alphanumeric Only)',
    difficulty: 'Easy',
    duration: 20,
    prompt: 'Check if a string is a palindrome ignoring case and non-alphanumeric characters.',
    problemStatement:
      'Given a string s, consider only letters and digits, compare case-insensitively. Return true if it reads the same forward and backward.',
    sampleInput: '"A man, a plan, a canal: Panama"',
    sampleOutput: 'true',
    evaluationLogic: [
      'Strips non-alphanumeric',
      'Two-pointer compare',
      'Handles empty after strip',
    ],
    starterByLanguage: {
      javascript: 'function isPalindrome(s) {\n  // Write your code here\n}\n',
      nodejs: 'function isPalindrome(s) {\n  // Write your code here\n}\nmodule.exports = { isPalindrome };\n',
      python: 'def is_palindrome(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public boolean isPalindrome(String s) {\n    // Write your code here\n    return false;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function isPalindrome(s) {\n  const cleaned = s.toLowerCase().replace(/[^a-z0-9]/g, "");\n  let i = 0;\n  let j = cleaned.length - 1;\n  while (i < j) {\n    if (cleaned[i] !== cleaned[j]) return false;\n    i += 1;\n    j -= 1;\n  }\n  return true;\n}\n',
      nodejs:
        'function isPalindrome(s) {\n  const cleaned = s.toLowerCase().replace(/[^a-z0-9]/g, "");\n  let i = 0;\n  let j = cleaned.length - 1;\n  while (i < j) {\n    if (cleaned[i] !== cleaned[j]) return false;\n    i += 1;\n    j -= 1;\n  }\n  return true;\n}\nmodule.exports = { isPalindrome };\n',
      python:
        'def is_palindrome(s):\n    cleaned = "".join(ch.lower() for ch in s if ch.isalnum())\n    return cleaned == cleaned[::-1]\n',
      java:
        'class Solution {\n  public boolean isPalindrome(String s) {\n    String cleaned = s.replaceAll("[^A-Za-z0-9]", "").toLowerCase();\n    int i = 0, j = cleaned.length() - 1;\n    while (i < j) {\n      if (cleaned.charAt(i) != cleaned.charAt(j)) return false;\n      i++;\n      j--;\n    }\n    return true;\n  }\n}\n',
    },
  },
  {
    id: 'capitalize-words',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Capitalize Words',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Capitalize the first letter of each word (space-separated).',
    problemStatement:
      'Given a string s with words separated by single spaces, return a new string with the first letter of each word uppercased and the remaining letters lowercased.',
    sampleInput: '"hello WORLD test"',
    sampleOutput: '"Hello World Test"',
    evaluationLogic: [
      'Splits on spaces',
      'Normalizes each word',
      'Preserves single-space separation',
    ],
    starterByLanguage: {
      javascript: 'function capitalizeWords(s) {\n  // Write your code here\n}\n',
      nodejs:
        'function capitalizeWords(s) {\n  // Write your code here\n}\nmodule.exports = { capitalizeWords };\n',
      python: 'def capitalize_words(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String capitalizeWords(String s) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function capitalizeWords(s) {\n  return s\n    .split(" ")\n    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""))\n    .join(" ");\n}\n',
      nodejs:
        'function capitalizeWords(s) {\n  return s\n    .split(" ")\n    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""))\n    .join(" ");\n}\nmodule.exports = { capitalizeWords };\n',
      python:
        'def capitalize_words(s):\n    return " ".join(w[:1].upper() + w[1:].lower() if w else "" for w in s.split(" "))\n',
      java:
        'class Solution {\n  public String capitalizeWords(String s) {\n    String[] parts = s.split(" ");\n    StringBuilder b = new StringBuilder();\n    for (int i = 0; i < parts.length; i++) {\n      String w = parts[i];\n      if (w.isEmpty()) continue;\n      b.append(Character.toUpperCase(w.charAt(0)));\n      b.append(w.substring(1).toLowerCase());\n      if (i < parts.length - 1) b.append(" ");\n    }\n    return b.toString();\n  }\n}\n',
    },
  },
  {
    id: 'reverse-string',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Reverse String',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Return the characters of the string in reverse order.',
    problemStatement: 'Given a string s, return a new string with all characters reversed.',
    sampleInput: '"abcdef"',
    sampleOutput: '"fedcba"',
    evaluationLogic: ['Reverses full string', 'Handles empty string', 'Unicode-safe at string level'],
    starterByLanguage: {
      javascript: 'function reverseString(s) {\n  // Write your code here\n}\n',
      nodejs: 'function reverseString(s) {\n  // Write your code here\n}\nmodule.exports = { reverseString };\n',
      python: 'def reverse_string(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String reverseString(String s) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function reverseString(s) {\n  return s.split("").reverse().join("");\n}\n',
      nodejs:
        'function reverseString(s) {\n  return s.split("").reverse().join("");\n}\nmodule.exports = { reverseString };\n',
      python: 'def reverse_string(s):\n    return s[::-1]\n',
      java:
        'class Solution {\n  public String reverseString(String s) {\n    return new StringBuilder(s).reverse().toString();\n  }\n}\n',
    },
  },
  {
    id: 'mask-string-last-four',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Mask String (Reveal Last 4)',
    difficulty: 'Easy',
    duration: 15,
    prompt: 'Replace all but the last four characters with asterisks.',
    problemStatement:
      'Given a string s (length at least 4), return a string of the same length where every character except the last four is "*".',
    sampleInput: '"1234567890"',
    sampleOutput: '"******7890"',
    evaluationLogic: [
      'Preserves last four characters',
      'Pads earlier positions with asterisks',
      'Handles minimum length inputs',
    ],
    starterByLanguage: {
      javascript: 'function maskLastFour(s) {\n  // Write your code here\n}\n',
      nodejs: 'function maskLastFour(s) {\n  // Write your code here\n}\nmodule.exports = { maskLastFour };\n',
      python: 'def mask_last_four(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public String maskLastFour(String s) {\n    // Write your code here\n    return "";\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function maskLastFour(s) {\n  if (s.length <= 4) return s;\n  return "*".repeat(s.length - 4) + s.slice(-4);\n}\n',
      nodejs:
        'function maskLastFour(s) {\n  if (s.length <= 4) return s;\n  return "*".repeat(s.length - 4) + s.slice(-4);\n}\nmodule.exports = { maskLastFour };\n',
      python:
        'def mask_last_four(s):\n    s = str(s)\n    if len(s) <= 4:\n        return s\n    return "*" * (len(s) - 4) + s[-4:]\n',
      java:
        'class Solution {\n  public String maskLastFour(String s) {\n    if (s.length() <= 4) return s;\n    StringBuilder b = new StringBuilder();\n    for (int i = 0; i < s.length() - 4; i++) b.append(\'*\');\n    b.append(s.substring(s.length() - 4));\n    return b.toString();\n  }\n}\n',
    },
  },
  {
    id: 'compare-version-strings',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Compare Version Strings',
    difficulty: 'Hard',
    duration: 28,
    prompt: 'Compare two semantic version strings.',
    problemStatement:
      'Given two version strings v1 and v2 consisting of non-negative integers separated by ".", return -1 if v1 < v2, 1 if v1 > v2, and 0 if equal. Ignore leading zeros in each component; trailing zero components are ignored (1.0 equals 1.0.0).',
    sampleInput: 'v1="1.01", v2="1.001"',
    sampleOutput: '0',
    evaluationLogic: [
      'Splits numeric components correctly',
      'Strips leading zeros per component',
      'Handles unequal component counts',
    ],
    starterByLanguage: {
      javascript: 'function compareVersion(v1, v2) {\n  // Write your code here\n}\n',
      nodejs:
        'function compareVersion(v1, v2) {\n  // Write your code here\n}\nmodule.exports = { compareVersion };\n',
      python: 'def compare_version(v1, v2):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int compareVersion(String v1, String v2) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function compareVersion(v1, v2) {\n  const a = v1.split(".").map((x) => parseInt(x, 10));\n  const b = v2.split(".").map((x) => parseInt(x, 10));\n  const n = Math.max(a.length, b.length);\n  for (let i = 0; i < n; i += 1) {\n    const x = i < a.length ? a[i] : 0;\n    const y = i < b.length ? b[i] : 0;\n    if (x < y) return -1;\n    if (x > y) return 1;\n  }\n  return 0;\n}\n',
      nodejs:
        'function compareVersion(v1, v2) {\n  const a = v1.split(".").map((x) => parseInt(x, 10));\n  const b = v2.split(".").map((x) => parseInt(x, 10));\n  const n = Math.max(a.length, b.length);\n  for (let i = 0; i < n; i += 1) {\n    const x = i < a.length ? a[i] : 0;\n    const y = i < b.length ? b[i] : 0;\n    if (x < y) return -1;\n    if (x > y) return 1;\n  }\n  return 0;\n}\nmodule.exports = { compareVersion };\n',
      python:
        'def compare_version(v1, v2):\n    a = [int(x) for x in v1.split(".")]\n    b = [int(x) for x in v2.split(".")]\n    n = max(len(a), len(b))\n    for i in range(n):\n        x = a[i] if i < len(a) else 0\n        y = b[i] if i < len(b) else 0\n        if x < y:\n            return -1\n        if x > y:\n            return 1\n    return 0\n',
      java:
        'class Solution {\n  public int compareVersion(String v1, String v2) {\n    String[] a = v1.split("\\\\.");\n    String[] b = v2.split("\\\\.");\n    int n = Math.max(a.length, b.length);\n    for (int i = 0; i < n; i++) {\n      int x = i < a.length ? Integer.parseInt(a[i]) : 0;\n      int y = i < b.length ? Integer.parseInt(b[i]) : 0;\n      if (x < y) return -1;\n      if (x > y) return 1;\n    }\n    return 0;\n  }\n}\n',
    },
  },
  {
    id: 'max-parentheses-depth',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Maximum Nested Parentheses Depth',
    difficulty: 'Medium',
    duration: 20,
    prompt: 'Find the maximum nesting depth of parentheses in a balanced string.',
    problemStatement:
      'Given a balanced string s of "(" and ")" only, return the maximum number of nested open parentheses at any position during a left-to-right scan.',
    sampleInput: '"(())()"',
    sampleOutput: '2',
    evaluationLogic: [
      'Tracks running depth',
      'Records peak depth',
      'Assumes balanced input',
    ],
    starterByLanguage: {
      javascript: 'function maxParenDepth(s) {\n  // Write your code here\n}\n',
      nodejs: 'function maxParenDepth(s) {\n  // Write your code here\n}\nmodule.exports = { maxParenDepth };\n',
      python: 'def max_paren_depth(s):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int maxParenDepth(String s) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function maxParenDepth(s) {\n  let d = 0;\n  let best = 0;\n  for (const ch of s) {\n    if (ch === "(") {\n      d += 1;\n      best = Math.max(best, d);\n    } else d -= 1;\n  }\n  return best;\n}\n',
      nodejs:
        'function maxParenDepth(s) {\n  let d = 0;\n  let best = 0;\n  for (const ch of s) {\n    if (ch === "(") {\n      d += 1;\n      best = Math.max(best, d);\n    } else d -= 1;\n  }\n  return best;\n}\nmodule.exports = { maxParenDepth };\n',
      python:
        'def max_paren_depth(s):\n    d = best = 0\n    for ch in s:\n        if ch == "(":\n            d += 1\n            best = max(best, d)\n        else:\n            d -= 1\n    return best\n',
      java:
        'class Solution {\n  public int maxParenDepth(String s) {\n    int d = 0, best = 0;\n    for (char ch : s.toCharArray()) {\n      if (ch == \'(\') {\n        d++;\n        best = Math.max(best, d);\n      } else d--;\n    }\n    return best;\n  }\n}\n',
    },
  },
  {
    id: 'subarray-sum-equals-k',
    pack: CODING_TEMPLATE_PACK.FRONTEND,
    title: 'Subarray Sum Equals K (Count)',
    difficulty: 'Hard',
    duration: 35,
    prompt: 'Count contiguous subarrays whose sum equals k.',
    problemStatement:
      'Given an integer array nums and an integer k, return the number of contiguous non-empty subarrays whose elements sum to k.',
    sampleInput: 'nums=[1,1,1], k=2',
    sampleOutput: '2',
    evaluationLogic: [
      'Uses prefix sums with a hash map',
      'Runs in O(n) time',
      'Counts overlapping subarrays correctly',
    ],
    starterByLanguage: {
      javascript: 'function subarraySum(nums, k) {\n  // Write your code here\n}\n',
      nodejs: 'function subarraySum(nums, k) {\n  // Write your code here\n}\nmodule.exports = { subarraySum };\n',
      python: 'def subarray_sum(nums, k):\n    # Write your code here\n    pass\n',
      java:
        'class Solution {\n  public int subarraySum(int[] nums, int k) {\n    // Write your code here\n    return 0;\n  }\n}\n',
    },
    expectedByLanguage: {
      javascript:
        'function subarraySum(nums, k) {\n  const prefix = new Map([[0, 1]]);\n  let sum = 0;\n  let count = 0;\n  for (const n of nums) {\n    sum += n;\n    count += prefix.get(sum - k) || 0;\n    prefix.set(sum, (prefix.get(sum) || 0) + 1);\n  }\n  return count;\n}\n',
      nodejs:
        'function subarraySum(nums, k) {\n  const prefix = new Map([[0, 1]]);\n  let sum = 0;\n  let count = 0;\n  for (const n of nums) {\n    sum += n;\n    count += prefix.get(sum - k) || 0;\n    prefix.set(sum, (prefix.get(sum) || 0) + 1);\n  }\n  return count;\n}\nmodule.exports = { subarraySum };\n',
      python:
        'def subarray_sum(nums, k):\n    from collections import defaultdict\n    pref = defaultdict(int)\n    pref[0] = 1\n    total = count = 0\n    for n in nums:\n        total += n\n        count += pref[total - k]\n        pref[total] += 1\n    return count\n',
      java:
        'class Solution {\n  public int subarraySum(int[] nums, int k) {\n    java.util.Map<Integer, Integer> pref = new java.util.HashMap<>();\n    pref.put(0, 1);\n    int sum = 0, count = 0;\n    for (int n : nums) {\n      sum += n;\n      count += pref.getOrDefault(sum - k, 0);\n      pref.put(sum, pref.getOrDefault(sum, 0) + 1);\n    }\n    return count;\n  }\n}\n',
    },
  },
];

